export function organizationShareLine(shared) {
  return shared
    ? 'Organization messages are shared.'
    : 'Each person sees the messages they sent.';
}

/**
 * Confirmation for Save notifications.
 * Sharing is mentioned when that choice changed. Other alerts get the general save line.
 */
export function notificationSaveNote({
  shared = false,
  canManage = false,
  sharingChanged = false,
  notificationsChanged = false,
  sharingSaved = false,
  accountSaved = false,
  error = '',
} = {}) {
  const mentionShare = canManage && sharingChanged;
  const shareLine = organizationShareLine(shared);

  if (mentionShare && (error || !sharingSaved)) {
    const detail = error || 'Organization message sharing was not saved.';
    const lead = notificationsChanged && accountSaved ? 'Notifications saved. ' : '';
    return { error: true, text: `${lead}${detail}` };
  }

  if (mentionShare && !notificationsChanged) {
    return {
      error: false,
      text: accountSaved ? `Saved. ${shareLine}` : `Saved on this browser. ${shareLine}`,
    };
  }

  if (mentionShare) {
    return {
      error: false,
      text: accountSaved
        ? `Notifications saved. ${shareLine}`
        : `Saved on this browser. ${shareLine}`,
    };
  }

  return accountSaved
    ? { error: false, text: 'Notifications saved.' }
    : { error: false, text: 'Notifications saved on this browser.' };
}
